import { render, staticRenderFns } from "./BaseNumberCard.vue?vue&type=template&id=50be5061&scoped=true&"
import script from "./BaseNumberCard.vue?vue&type=script&lang=js&"
export * from "./BaseNumberCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseNumberCard.vue?vue&type=style&index=0&id=50be5061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50be5061",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
